import * as Yup from 'yup';

export const validationSchema: Yup.ObjectSchema<{}> = Yup.object().shape({
  name: Yup.string().trim().required('Please enter category name.')
});
